import React, { Component } from 'react'

class InsightcareFooter extends Component {
  render() {
    return (
      <footer>
          <div className="col-sm-6">
              <p>{this.props.hospitalName}</p>
          </div>
          <div id="current-time" className="col-sm-6 text-right">
              <p><b>{this.props.dateHour}</b></p>
          </div>
      </footer>
    )
  }
}

export default InsightcareFooter
